/* global gtag */

export async function TrackClick(caller) {
    TrackClickById(caller.id);
}
export async function TrackClickById(id) {
    if (typeof gtag != "undefined") {
        gtag('event', 'click', {
            'link_id': id
        });
    }
}